<template>
    <div class="grid grid-cols-4 gap-5">
        <div class="col-span-3 pr-5 border-r-2 space-y-4">
            <div class="grid grid-cols-3 gap-4">
                <div class="col-span-3">
                    <JetLabelRequired for="title" value="Titre" />
                    <JetInput
                        v-model="form.title" type="text"
                        maxlength="255" placeholder="Entrer le titre du message"
                    />
                    <JetInputError :message="form.errors?.title" />
                </div>
                <div class="col-span-1">
                    <JetLabelRequired value="Type" />
                    <select v-model="form.type" class="form-input w-full">
                        <option value="" disabled>Choisissez le type de message</option>
                        <option v-for="item in types" :key="item.value" :value="item.value">
                            {{ item.label }}
                        </option>
                    </select>
                    <JetInputError :message="form.errors?.type" />
                </div>
    
                <div class="col-span-1">
                    <JetLabelRequired value="Importance" />
                    <select v-model="form.importance" class="form-input w-full">
                        <option value="" disabled>Choisissez l'importance</option>
                        <option v-for="item in importances" :key="item.value" :value="item.value">
                            {{ item.label }}
                        </option>
                    </select>
                    <JetInputError :message="form.errors?.importance" />
                </div>

                <div class="col-span-1">
                    <JetLabel value="Priorité" />
                    <JetInput v-model="form.priority" type="number" min="0" placeholder="0" />
                    <JetInputError :message="form.errors?.priority" />
                </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
                <div>
                    <JetLabelRequired for="message" value="Message" />
                    <textarea
                        id="message" v-model="form.message"
                        class="form-input w-full" rows="8" maxlength="120"
                        placeholder="Entrer le message ici ..."
                    ></textarea>
                    <JetInputError :message="form.errors?.message" />
                </div>

                <ImageUploader v-model="form.image" :current="imagePreview" />
            </div>

            <RolesSelector v-model="form.roles" :roles="roles" />
            
            <div class="grid grid-cols-3 gap-4 p-2 mt-2 border">
                <label class="flex items-center space-x-2">
                    <input v-model="form.dismissible" type="checkbox" class="form-checkbox text-greendack-700" />
                    <span>Fermable</span>
                </label>

                <label class="flex items-center space-x-2">
                    <input v-model="form.show_once" type="checkbox" class="form-checkbox text-greendack-700" />
                    <span>Une seule fois</span>
                </label>

                <label class="flex items-center space-x-2">
                    <input v-model="form.force_display" type="checkbox" class="form-checkbox text-greendack-700" />
                    <span>Obligatoire</span>
                </label>
            </div>

            <ActionFields
                v-model:type="form.action_type"
                v-model:label="form.action_label"
                v-model:payload="form.action_payload"

                :actions="actions"
                :packages="packages"
                :travels="travels"

                :errors="form.errors || {}"
            />
        </div>

        <div class="col-span-1">
            <PreviewCard
                :type="form.type"
                :title="form.title"
                :message="form.message"
                :image="imagePreview"
                :action-label="form.action_label"
            />
        </div>
    </div>
</template>

<script>
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetLabelRequired from '@/Jetstream/LabelRequired'

    import PreviewCard from './PreviewCard.vue'
    import ActionFields from './ActionFields.vue'
    import RolesSelector from './RolesSelector.vue'
    import ImageUploader from './ImageUploader.vue'

    export default {
        components: {
            JetLabel,
            JetInput,
            JetInputError,
            JetLabelRequired,

            PreviewCard,
            ActionFields,
            RolesSelector,
            ImageUploader
        },

        props: {
            form: {
                type: Object,
                required: true
            },

            types: {
                type: Array,
                default: () => []
            },

            importances: {
                type: Array,
                default: () => []
            },

            roles: {
                type: Array,
                default: () => []
            },

            actions: {
                type: Array,
                default: () => []
            },

            packages: {
                type: Array,
                default: () => []
            },

            travels: {
                type: Array,
                default: () => []
            },

            currentImage: {
                type: String,
                default: null
            }
        },

        computed: {
            imagePreview() {
                if (this.form.image instanceof File) {
                    return URL.createObjectURL(
                        this.form.image
                    )
                }

                return this.currentImage
            }
        }
    }
</script>